/**
 * Установка cookie с указанным именем, значением и опциями
 * 
 * @param name - Имя cookie
 * @param value - Значение cookie
 * @param days - Срок действия cookie в днях
 */
export const setCookie = (name: string, value: string, days = 7): void => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;

    const domain = window.location.hostname;

    // Устанавливаем cookie с разными вариантами path и domain для совместимости
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
    document.cookie = `${name}=${value};${expires};path=/;domain=${domain};SameSite=Strict`;
};

/**
 * Установка cookie с истечением срока в секундах
 * 
 * @param name - Имя cookie
 * @param value - Значение cookie
 * @param seconds - Срок действия cookie в секундах
 */
export const setCookieWithExpiresIn = (name: string, value: string, seconds: number): void => {
    const date = new Date();
    date.setTime(date.getTime() + (seconds * 1000));
    const expires = `expires=${date.toUTCString()}`;

    const domain = window.location.hostname;

    // Устанавливаем cookie с разными вариантами path и domain для совместимости
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
    document.cookie = `${name}=${value};${expires};path=/;domain=${domain};SameSite=Strict`;
};

/**
 * Получение значения cookie по имени
 * 
 * @param name - Имя cookie
 * @returns Значение cookie или null, если cookie не найдена
 */
export const getCookie = (name: string): string | null => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
};

/**
 * Удаление cookie по имени
 * 
 * @param name - Имя cookie для удаления
 */
export const deleteCookie = (name: string): void => {
    // Устанавливаем несколько вариантов для надежного удаления cookie
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;

    // Также для поддоменов
    const domain = window.location.hostname;
    const domainParts = domain.split('.');

    if (domainParts.length > 2) {
        const topLevelDomain = domainParts.slice(domainParts.length - 2).join('.');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${topLevelDomain};`;
    }
};

/**
 * Проверяет, истек ли срок действия токена
 * 
 * @returns true если токен истек или отсутствует, false если токен действителен
 */
export const isTokenExpired = (): boolean => {
    const tokenExpires = getCookie('token_expires');

    if (!tokenExpires) {
        return true;
    }

    const expiryTime = parseInt(tokenExpires, 10);
    const currentTime = Math.floor(Date.now() / 1000);

    return currentTime >= expiryTime;
};

/**
 * Сохраняет токены авторизации в куки
 * 
 * @param accessToken - Токен доступа
 * @param refreshToken - Токен обновления
 * @param expiresIn - Время жизни токена в секундах
 * @param path - Путь для сохранения куки (по умолчанию: '/')
 */
export const saveAuthTokens = (
    accessToken: string,
    refreshToken: string,
    expiresIn: number,
    path = '/'
): void => {
    // Сохраняем токены в куки
    setCookie('access_token', accessToken, 7);
    setCookie('refresh_token', refreshToken, 30);  // Refresh токен храним дольше

    // Вычисляем и сохраняем время истечения токена
    const expiryDate = new Date();
    expiryDate.setSeconds(expiryDate.getSeconds() + expiresIn);

    // Для совместимости с разными форматами
    setCookie('token_expires_at', expiryDate.getTime().toString(), 7);
    setCookie('token_expires', Math.floor(expiryDate.getTime() / 1000).toString(), 7);

    // Запоминаем время логина
    localStorage.setItem('last_login_time', Date.now().toString());
}; 